import { createLoadingSpinnerComponent } from '@vfde-brix/loading-spinner';

/**
 * Mount loading spinner
 * @param container
 */
export const mountLoadingSpinner = (container) => {
    const spinner = document.getElementById(container);

    return createLoadingSpinnerComponent(spinner, {
        optIsVisible: false,
        business: {},
    });
};
